export const light = {
  text: '#404A59',
  strokebar: '#E5E9F1',
  card: '#FFFFFF',
  header: '#F9FBFC',
  background: '#FFFFFF',
  sidebar: '#FFFFFF',
};

export const dark = {
  text: '#FFFFFF',
  strokebar: '#51595C',
  card: '#3A3D41',
  header: '#3A3D41',
  background: '#323538',
  sidebar: '#292C2D',
};

export const rainbow = {
  white: '#FFFFFF',
  black: '#000000',

  gray: {
    '50': '#F9F9F9',
    '100': '#ECEEF2',
    '200': '#D5DBE2',
    '300': '#B0BBC9',
    '400': '#8595AB',
    '500': '#667991',
    '600': '#52627A',
    '700': '#424F62',
    '800': '#394353',
    '900': '#333B47',
  },

  blue: {
    '50': '#EEF8FF',
    '100': '#D8EFFF',
    '200': '#B9E4FF',
    '300': '#8AD4FF',
    '400': '#52BCFF',
    '500': '#2A9CFF',
    '600': '#137DFD',
    '700': '#0C63E4',
    '800': '#1151BC',
    '900': '#144794',
  },

  sucess: {
    '50': '#EEFFF6',
    '100': '#D7FFEB',
    '200': '#B1FFD9',
    '300': '#75FFBC',
    '400': '#32F696',
    '500': '#07D471',
    '600': '#00BA60',
    '700': '#04914E',
    '800': '#097241',
    '900': '#0A5D37',
  },

  link: {
    '50': '#EBFEFF',
    '100': '#CDF9FF',
    '200': '#A2F1FF',
    '300': '#62E5FE',
    '400': '#19CEF5',
    '500': '#00B1DB',
    '600': '#028DB8',
    '700': '#097195',
    '800': '#125B78',
    '900': '#134B66',
  },

  warning: {
    '50': '#FFF7EB',
    '100': '#FDE8C8',
    '200': '#FBD18C',
    '300': '#F8B351',
    '400': '#F79C31',
    '500': '#F07510',
    '600': '#D5520A',
    '700': '#B1350C',
    '800': '#8F2A11',
    '900': '#762411',
  },

  error: {
    '50': '#FFF1F2',
    '100': '#FFE4E6',
    '200': '#FFCCD3',
    '300': '#FEA3AE',
    '400': '#FD6F84',
    '500': '#F63858',
    '600': '#E31B46',
    '700': '#C0103A',
    '800': '#A11038',
    '900': '#891236',
  },

  yellow: {
    '50': '#FEFCEC',
    '100': '#FDF5C8',
    '200': '#FAEB8D',
    '300': '#F7DB52',
    '400': '#F6CE3C',
    '500': '#EFAA11',
    '600': '#D3840C',
    '700': '#AF5E0E',
    '800': '#8E4912',
    '900': '#753C12',
  },

  gbm: {
    sky: '#0C63E4',
    ocean: '#094FB9',
    blue: '#033278',
  },

  componentColors: {
    stroke: '#dae0e7',
  },
};

export const themes = {
  light,
  dark,
  rainbow,
};
